import { Params, useParams } from "react-router-dom";
import { isTaskDMP } from "tm-shared/utils";

import { usePointSelector, useTaskSelector } from "@/hooks/redux";
import NotFound from "@/pages/System/NotFound";

import { DMPPage } from "./DMPPage";

interface DMPParams extends Params {
    pointId: string;
    taskId: string;
}

const DMP = () => {
    const { pointId = "", taskId = "" } = useParams<DMPParams>();

    const currentPoint = usePointSelector(pointId);
    const currentTask = useTaskSelector(pointId, taskId);

    if (!currentPoint || !currentTask || !isTaskDMP(currentTask)) {
        return <NotFound />;
    }

    return <DMPPage task={currentTask} point={currentPoint} />;
};

export default DMP;
